import { FolderOpen } from 'lucide-react'
import type { ReactNode } from 'react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Assets } from 'src/shared/components/organizationPage/BrandSettings'
import { PageContainer } from 'src/shared/components/PageContainer'
import { useLocalization } from 'src/shared/hooks/useLocalization'

type AssetsPageProps = {
  embedded?: boolean
}

export const AssetsPage = (props: AssetsPageProps = {}) => {
  const { embedded = false } = props
  const { t } = useLocalization()

  const shell = (children: ReactNode) =>
    embedded ? (
      <Column className="gap-4">{children}</Column>
    ) : (
      <PageContainer className="gap-4">{children}</PageContainer>
    )

  return shell(
    <Column className="gap-4">
      {!embedded && (
        <Row className="items-center gap-2">
          <FolderOpen size={20} strokeWidth={2} className="shrink-0" />
          <h1>{t('Assets', 'Filer')}</h1>
        </Row>
      )}
      <p className="text-sm md:text-base text-gray-600">
        {t(
          'Logos, proofs, and brand files for your workspace.',
          'Logotyper, korrektur och varumärkesfiler för din arbetsyta.'
        )}
      </p>
      <Assets />

      <div className="h-10" />
    </Column>
  )
}
